"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var owa_options_core_1 = require("owa-options-core");
var store_1 = require("../store/store");
var owa_session_store_1 = require("owa-session-store");
var legacy_1 = require("satcheljs/lib/legacy");
exports.default = legacy_1.select({
    optionState: function () { return store_1.default; },
    userOptions: function () { return owa_session_store_1.getUserConfiguration().UserOptions; },
})(function isReplyOptionDirty(state) {
    var savedOptions = state.userOptions;
    var replyAllByDefault = owa_options_core_1.getFallbackValueIfNull(state.optionState.replyAllByDefault, savedOptions.IsReplyAllTheDefaultResponse);
    return replyAllByDefault !== savedOptions.IsReplyAllTheDefaultResponse;
});
//# sourceMappingURL=isReplyOptionDirty.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/config/mail/owa-reply-option/lib/utils/isReplyOptionDirty.js
// module id = 5051
// module chunks = 2